export default "__VITE_ASSET__3684345c__"